





































































import Vue from 'vue';
import { HTTP } from '@/utils/httpCommonUtil'
import VueSimpleSpinner from 'vue-simple-spinner'
import { BallPulseLoader } from 'vue-loaders';
import facilityEventHub from '@/components/facility/FacilityEventHub';
import GenericModal from '@/componentsReusable/genericModal.vue';
import SpecialtyModal from '@/componentsReusable/SpecialtyModal.vue';

export default Vue.component('facility-specialty-control', {
  name: 'FacilitySpecialtyControl',
  props: {
    // 'show-modal': {
    //   type: Boolean,
    //   default: false
    // },
    // 'facility-id': {
      // type: Number
    // },
  },
  data () {
    return {
      selectedSpecialty: '',
      loadingFacilitySpecialty: true,
      loadingFacilitySpecialtyCandidates: false,
      facilitySpecialties: [],
      assignedSpecialties: [],
      nonAssignedSpecialties: [],
      showDropdown: false,
      showConfirmationModal: false,
      pendingRemoveSpecialty: null,
      showSpecialtySelectionModal: false,
    }
  },
  components: {
    VueSimpleSpinner,
    BallPulseLoader,
    GenericModal,
    SpecialtyModal
  },
  mounted: function () {
    this.getFacilitySpecialties();
  },
  filters: {
    shortName (shortName: string ) {
      if (shortName && shortName.length) {
        return '(' + shortName + ')';
      }
      return '';
    },
    selectedSpecialtyText (specialtyName: string ) {
      return (specialtyName && specialtyName.length) ? specialtyName : "Select Specialty";
    },
  },
  methods: {
    toggleDropdown () {
      this.showDropdown = !this.showDropdown;
      if (this.showDropdown) {
        let self = this
        let showSpecialtyCandidateLoaderTimeout = setTimeout(function () {
          self.loadingFacilitySpecialtyCandidates = true;
        }, this.facilitySpecialties.length ? 1000 : 0);
        HTTP.get('/api/facilities/' + this.$route.params.facilityId + '/specialties')
        .then(function (response) {
          clearTimeout(showSpecialtyCandidateLoaderTimeout);
          self.loadingFacilitySpecialtyCandidates = false;
          if (!response.data || !response.data.data ) {
            throw new Error("Error retrieving facility specialty candidates.");
          }
          self.facilitySpecialties = response.data.data;
          self.separareSpecialties(self.facilitySpecialties);
        })
        .catch(function (err) {
          console.log(err);
          clearTimeout(showSpecialtyCandidateLoaderTimeout);
          self.loadingFacilitySpecialtyCandidates = false;
          self.$notify({
            group: 'main',
            type: 'error',
            title: 'Error',
            text: 'An error occurred loading facility specialties.'
          });
        })
      }
    },
    separareSpecialties (facilitySpecialties: any) {
      let self = this as any;
      self.assignedSpecialties = [];
      self.nonAssignedSpecialties = [];
      self.facilitySpecialties.forEach(function (specialty: any) {
        if (specialty.facilityId) {
          self.assignedSpecialties.push(specialty);
        } else {
          self.nonAssignedSpecialties.push(specialty);
        }
      });
    },
    assignSpecialtyName (facilitySpecialties: any) {
      let self = this;
      self.facilitySpecialties.forEach(function (specialty: any) {
        if (Number(specialty.specialtyId) === Number(self.$route.params.specialtyId)) {
          self.selectedSpecialty = specialty.specialtyName;
        }
      });
    },
    getFacilitySpecialties () {
      let self = this
      HTTP.get('/api/facilities/' + this.$route.params.facilityId + '/specialties')
      .then(function (response) {
        self.loadingFacilitySpecialtyCandidates = false;
        if (!response.data || !response.data.data ) {
          throw new Error("Error retrieving facility's specialties.");
        }
        self.facilitySpecialties = response.data.data;
        self.separareSpecialties(self.facilitySpecialties);
        self.assignSpecialtyName(self.facilitySpecialties);
      })
      .catch(function (err) {
        console.log(err);
        // clearTimeout(showLoadingSpinnerTimeout);
        self.loadingFacilitySpecialtyCandidates = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred fetching this facility\'s specialties.'
        });
      })
    },
    specialtySelected (specialty: any) {
      this.showDropdown = false;
      if (this.selectedSpecialty !== specialty.specialtyName) {
        facilityEventHub.$emit('SPECIALTY_CHANGE', specialty.specialtyId)
      }
      this.selectedSpecialty = specialty.specialtyName;
      this.$router.push({name: 'FacilitySpecialty', params: {facilityId: specialty.facilityId, specialtyId: specialty.specialtyId}});
    },

    removeConfirmed () {
      this.showConfirmationModal = false;
      this.removeSpecialty(this.pendingRemoveSpecialty, true);
    },
    removeSpecialty (specialty: any, bypassDeleteConfirmation: boolean = false) {
      // To prevent a double submit
      if (specialty.updatingData) { console.log("returning."); return ; }

      if (!bypassDeleteConfirmation) {
        // Show Delete Confirmation Modal
        this.showConfirmationModal = true;
        this.pendingRemoveSpecialty = specialty;
        return;
      } else {
        this.pendingRemoveSpecialty = null;
      }

      let self = this
      specialty.updatingData = true;
      HTTP.delete('/api/facilities/' + this.$route.params.facilityId + '/specialties/' + specialty.facilitySpecialtyAssocId)
      .then(function (response) {
        if (!response.data.success) {
          throw new Error("Error removing Facility's Specialty.");
        } else {
          self.loadingFacilitySpecialtyCandidates = true;
          self.getFacilitySpecialties();
          self.$notify({
            group: 'main',
            type: 'success',
            title: 'Successful Removal',
            text: 'Specialty has been successfully removed.'
          });
          facilityEventHub.$emit('SPECIALTY_ADDED_OR_REMOVED')
        }
      })
      .catch(function (err) {
        console.log(err);
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'Error removing Facility\'s Specialty.'
        });
      })
    },

    specialtyConfirmed (specialty: any) {
      this.addSpecialty(specialty);
    },
    addSpecialty (specialty: any) {
      if (!specialty) {
        // Show Delete Confirmation Modal
        this.showSpecialtySelectionModal = true;
        return;
      }
      // To prevent a double submit
      if (specialty.updatingData) { console.log("returning."); return ; }

      specialty.updatingData = true;
      let self = this
      HTTP.post('/api/facilities/' + this.$route.params.facilityId + '/specialties/', specialty)
      .then(function (response) {
        if (!response.data.success) {
          throw new Error("Error adding Facility's Specialty.");
        } else {
          self.loadingFacilitySpecialtyCandidates = true;
          self.showSpecialtySelectionModal = false;
          specialty.updatingData = false;
          self.getFacilitySpecialties();
          self.$notify({
            group: 'main',
            type: 'success',
            title: 'Successful Addition',
            text: 'Specialty has been successfully added.'
          });
          facilityEventHub.$emit('SPECIALTY_ADDED_OR_REMOVED')
        }
      })
      .catch(function (err) {
        console.log(err);
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'Error adding Facility\'s Specialty.'
        });
      })
    }
  }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/facility/facilityComponents/FacilitySpecialtyControl.vue